module.exports = __webpack_public_path__ + "img/Levis.9e81d5bd.jpg";